export const settings = state => state.settings
